/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {Component, Inject} from "@angular/core";

import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {environment} from "../../../../environments/environment";
import {BaseDialogComponent} from "../../../platform/base/components/base-dialog.component";
import {TranslateService} from "@ngx-translate/core";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-video-dialog",
	styleUrls: ["./video-dialog.component.css"],
	templateUrl: "./video-dialog.component.html",
})
export class VideoDialogComponent extends BaseDialogComponent {

	public endpoint: any;
	public smVideosSide: string[] = [];
	public smVideosBack: string[] = [];
	public prizmVideos: string[] = [];
	public smImages: any[] = [];
	public prizmImages: any[] = [];
	public shots: any[] = [];
	public layouts: any[] = [];
	public selected_layout: string;

	public prizm: boolean;
	public smVideo: boolean;
	public prizmVideo: boolean;

	private components: any[] = [

		{component: "app-list", visible: true, position: {x: 0, y: 0}, z_axis: 99, locked: true, maxSelected: 10},
		{component: "app-posture-chart", size: [600, 400], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true, maxSelected: 1, criterion: true},
		{component: "app-video-table", size: [600, 400], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true},
		{component: "app-video-table", size: [600, 400], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true},
		{component: "app-video-table", size: [600, 400], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true},
		{component: "app-patter-table", size: [600, 400], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true},
		{component: "app-patter-table", size: [600, 400], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true},
		{component: "app-posture-tab", size: [720, 360], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true},
		{component: "app-trajectory", size: [200, 400], visible: true, position: {x: 140, y: 0}, z_axis: 30, locked: true},
		{component: "app-score-table", size: [200, 200], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true, type: "", subtype: "スコア"},
		{component: "app-score-table", size: [200, 200], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true, type: "", subtype: "スコア"},
		{component: "app-ballistic-chart", size: [320, 240], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true, name: "ヘッドスピード"},
		{component: "app-ballistic-chart", size: [320, 240], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true, name: "ミート率"},
		{component: "app-ballistic-table", size: [400, 200], visible: true, position: {x: 80, y: 0}, z_axis: 30, locked: true},
		{component: "app-bar-chart", size: [200, 200], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true},
		{component: "app-score-table", size: [200, 200], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true, type: "ballistic", subtype: "ミート率"},
		{component: "app-line-chart", size: [320, 240], visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true},
		{component: "app-judgment", visible: true, position: {x: 0, y: 0}, z_axis: 30, locked: true},
	];

	/**
	 *
	 * @param data
	 * @param matDialogRef
	 * @param zone
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<VideoDialogComponent>,
		public translate: TranslateService
	) {
		super();
		this.endpoint = environment.endPoint;
	}

	/**
	 *
	 */
	public ngOnInit(): void {
	}

	/**
	 *
	 */
	public cancel(): void {
		this.matDialogRef.close(null);
	}

	/**
	 *
	 */
	public onAccept(): void {
		this.matDialogRef.close(this.data);
	}

}
